var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { Tool } from '../../../model/tool/Tool';
let ToolBox = class ToolBox extends LitElement {
    constructor() {
        super(...arguments);
        this.tools = [];
        this.stick = 'up';
        this.toggledWindow = null;
        this.map = this.parentElement || null;
    }
    getToggleWindowStyles() {
        if (!this.toggledWindow)
            return 'display:none;';
        const gap = 8; // space in pixels between toolbox and window
        let style = 'display:block;';
        switch (this.stick) {
            case 'up':
                style += `top:calc(100% + ${gap}px); left:50%; transform:translateX(-50%);`;
                break;
            case 'down':
                style += `bottom:calc(100% + ${gap}px); left:50%; transform:translateX(-50%);`;
                break;
            case 'left':
                style += `top:0; left:calc(100% + ${gap}px); transform:translateY(0);`;
                break;
            case 'right':
                style += `top:0; right:calc(100% + ${gap}px); transform:translateY(0);`;
                break;
        }
        return style;
    }
    toggleWindow(el) {
        if (this.toggledWindow?.className === el.className) {
            this.closeToggleWindow();
            return "close";
        }
        else {
            this.openToggleWindow(el);
            return "open";
        }
    }
    openToggleWindow(el) {
        this.toggledWindow = el;
    }
    closeToggleWindow() {
        if (!this.toggledWindow)
            return;
        this.toggledWindow = null;
    }
    render() {
        return html `
            ${this.tools.map(tool => html `
                <map-tool
                    .tool=${tool}
                    .map=${this.map}
                    .toolBox=${this}
                    size=${this.stick === 'down' || this.stick === 'left' ? 'large' : 'small'}
                ></map-tool>
            `)}

            <div id="toggle-window" style=${this.getToggleWindowStyles()}>
                ${this.toggledWindow ? html `${this.toggledWindow}` : ''}
            </div>
        `;
    }
};
ToolBox.styles = css `
        :host {
            position: absolute;
            display: flex;
            gap: 8px;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            z-index: 10;
        }

        /* Toolbox positions */
        :host([stick='up']) {
            top: 10px;
            left: 50%;
            transform: translateX(-50%);
            flex-direction: row;
            padding: 4px 12px;
        }

        :host([stick='down']) {
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            flex-direction: row;
            padding: 8px 16px;
        }

        :host([stick='left']) {
            top: 10px;
            left: 10px;
            flex-direction: column;
            padding: 16px 8px;
        }

        :host([stick='right']) {
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            flex-direction: column;
            padding: 12px 4px;
        }

        /* Toggle window base style */
        #toggle-window {
            position: absolute;
            background: white;
            border: 1px solid #ccc;
            border-radius: 6px;
            padding: 12px;
            box-shadow: 0 2px 12px rgba(0,0,0,0.2);
            z-index: 20;
        }
    `;
__decorate([
    property({ type: Array })
], ToolBox.prototype, "tools", void 0);
__decorate([
    property({ type: String, reflect: true })
], ToolBox.prototype, "stick", void 0);
__decorate([
    state()
], ToolBox.prototype, "toggledWindow", void 0);
ToolBox = __decorate([
    customElement('map-tool-box')
], ToolBox);
export { ToolBox };
//# sourceMappingURL=ToolBox.js.map